export default __webpack_public_path__ + "images/0x41adac6c1ff52c5e27568f27998d747f7b69795b.png";